'use client';

import React, { useState } from 'react';
import PlayMediaIcon from '../../assets/play_media_icon';

const PlayVideoButton = (props) => {
  const {
    fillColorCircle,
    fillColorArrow,
    size,
    onClick,
    hidden = false,
  } = props;

  const [isHidden, setIsHidden] = useState(hidden);

  return (
    <button
      className={isHidden ? 'hidden' : 'flex justify-center items-center'}
      onClick={() => {
        onClick();
        setIsHidden(true);
      }}
    >
      <PlayMediaIcon
        fillColorCircle={fillColorCircle}
        fillColorArrow={fillColorArrow}
        size={size}
      />
    </button>
  );
};

export default PlayVideoButton;
